import { Directive, Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { PdfDialogComponent } from './pdf-dialog/pdf-dialog.component';
import { TraceRouteDataUpdateType, TraceService } from '../../services/trace.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { take } from 'rxjs/operators';
import { MapService } from '@tt-lib/services/map.service';
import { BackEventService } from '@tt-lib/services/back-event.service';

// @Directive()
// export abstract class AsyncDialog<ComponentType> {//, DataType, ReturnType = unknown
//   constructor(protected matDialog: MatDialog) {
//   }
//   // abstract async open(data: DataType): Promise<MatDialogRef<ComponentType, ReturnType>>;
//   abstract open(): Promise<MatDialogRef<ComponentType>>;
// }

@Injectable({
  providedIn: 'root'
})
export class PdfService { ///extends AsyncDialog<PdfDialogComponent>{//, JobUserAssignDialogDataModel, UserModel
  public formatOptions = [
    {
      label: 'A5',
      value: 'a5',
      asWidthAndHeight: [210, 148],
    },
    {
      label: 'A4',
      value: 'a4',
      asWidthAndHeight: [297, 210],
    }, {
      label: 'A3',
      value: 'a3',
      asWidthAndHeight: [420, 297],
    }
  ];
  public orientationOptions = [
    {
      label: 'pdf.form.orientation.option.landscape',
      value: 'landscape'
    },
    {
      label: 'pdf.form.orientation.option.portrait',
      value: 'portrait'
    }
  ];
  public resolutionOptions = [
    {
      label: 'pdf.form.resolution.option.screen',
      type: 'screen',
      value: 1,
      // inDpi: 72
    },
    {
      label: 'pdf.form.resolution.option.print',
      type: 'print',
      value: 2,
      // inDpi: 150
    }//,
    // {
    //   label: 'pdf.form.resolution.option.quality',
    //   type: 'quality',
    //   value: 4,
    //   // inDpi: 
    // }
  ];
  private formData = {
    title: '',
    resolution: NaN,
    format: '',
    orientation: ''
  }
  private dialogRef: MatDialogRef<PdfDialogComponent>;
  private showPdfMapTipAgain: boolean = true;

  constructor(
    protected matDialog: MatDialog,
    public traceService: TraceService,
    private snackBar: MatSnackBar,
    private translateService: TranslateService,
    public mapService: MapService,
    private backEventService: BackEventService
  ) {
    //   super();
  }
  async open() {
    // (['postrender', 'change:size', 'change:view'] as any).forEach(evt =>
    //   this.mapService.getCurrentMap().on(evt, e => console.log('EVENT:', evt))
    // );

    //: Promise<MatDialogRef<PdfDialogComponent>> {//, UserModel
    // lazy load: importing a module asynchronously
    const importedModuleFile = await import('./pdf.module')
    const PdfComponent = importedModuleFile.PdfModule.getComponent()
    // const canvas = document.querySelectorAll('.ol-layer canvas')[0];
    document.getElementsByTagName('body')[0].classList.add('pdf-dialog-open');
    
    this.dialogRef = this.matDialog.open(
      PdfComponent
      , {
        data: {
          //sourceCanvas: canvas,
          title: this.formData.title || '',
          resolution: this.formData.resolution || 2,
          format: this.formData.format || 'a4',
          orientation: this.formData.orientation || 'portrait'
        },
        panelClass: 'pdf-dialog',
        width: '100%',
        maxWidth: '100vw !important',
        height: '100%',
        maxHeight: '100vh !important',
        closeOnNavigation: true,
      }
    );
    this.dialogRef.afterOpened().subscribe(_ => {
      if (this.showPdfMapTipAgain) { this.showPdfMapTip(); }

    })
    this.dialogRef.afterClosed().subscribe(formData => {
      //case backdropclick
      // if (!formData) {
      //   this.formData = dialogRef.componentInstance.data;
      //   console.dir(dialogRef.componentInstance.data)
      // } else {
      this.traceService.updatedTraceRouteData$.subscribe((traceRouteDataUpdateType: TraceRouteDataUpdateType) => {
        if (traceRouteDataUpdateType === 'new_data' || 'updated_metadata_info') {
          if (this.traceService.getTraceRouteData() && this.traceService.getTraceRouteData().metadata.name) {
            formData[0]!.value!.title = this.traceService.getTraceRouteData().metadata.name;
          }
        }
      });
      this.formData = formData[0].value;
      document.getElementsByTagName('body')[0].classList.remove('pdf-dialog-open');
    });
    this.dialogRef.beforeClosed().pipe(take(1)).subscribe(_ => this.snackBar.dismiss())

    this.backEventService.registerOpenedWindow({windowName: 'PdfComponent', isAutoCloseableWindow: true});
  }

  closeDialog() {
    this.dialogRef.close()
  }

  showPdfDownloadTip() {
    let msg = this.translateService.instant('pdf.download_tip');
    let snackBarRef = this.snackBar.open(msg, 'ok', {
      duration: 3500,
      horizontalPosition: 'right',
      verticalPosition: 'top'
    });
    snackBarRef.onAction().subscribe(() => {
      window.localStorage.setItem("dontShowPdfTipAgain", 'true');
    });
  };

  showPdfMapTip() {
    let msg = this.translateService.instant('pdf.pdf-map-tip');
    let snackBarRef = this.snackBar.open(msg, 'ok', {
      duration: 5500,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      panelClass: ['snack-dark-blue', 'pdftip']
    });
    snackBarRef.onAction().subscribe(() => {
      this.showPdfMapTipAgain = false;
    });
  };

}
